import { downscaleImage, uploadToCloudinary } from '../../utils/expressHelpers';

const MAX_PHOTOS = 8;
const MIN_PHOTOS = 3;

function StepDocuments({ state, patch, busy, onAnalyze, onSkip }) {
  const uploading = state.photos.some((p) => p.status === 'uploading');
  const doneCount = state.photos.filter((p) => p.status === 'done').length;
  const ready = Boolean(state.registrationFile) && doneCount >= MIN_PHOTOS && !uploading;

  const pickRegistration = async (file) => {
    if (!file || !file.type.startsWith('image/')) return;
    patch({ registrationFile: await downscaleImage(file, 2000, 0.9) }); // texte fin : on garde plus de définition
  };

  const addPhotos = (fileList) => {
    const room = MAX_PHOTOS - state.photos.length;
    const files = Array.from(fileList)
      .filter((f) => f.type.startsWith('image/'))
      .slice(0, room);

    files.forEach(async (file) => {
      const id = crypto.randomUUID();
      patch((s) => ({
        photos: [
          ...s.photos,
          { id, preview: URL.createObjectURL(file), url: null, status: 'uploading' },
        ],
      }));
      try {
        const url = await uploadToCloudinary(await downscaleImage(file));
        patch((s) => ({
          photos: s.photos.map((p) => (p.id === id ? { ...p, url, status: 'done' } : p)),
        }));
      } catch {
        patch((s) => ({
          photos: s.photos.map((p) => (p.id === id ? { ...p, status: 'error' } : p)),
        }));
      }
    });
  };

  const removePhoto = (photo) => {
    URL.revokeObjectURL(photo.preview);
    patch((s) => ({ photos: s.photos.filter((p) => p.id !== photo.id) }));
  };

  return (
    <section className="mc-form-card">
      <span className="mc-section-kicker">EXPRESS</span>
      <h1 className="mc-form-title">Votre annonce en 60 secondes</h1>
      <p className="mc-form-subtitle">
        Photographiez votre carte grise et ajoutez au moins {MIN_PHOTOS} photos. Nous remplissons le
        reste.
      </p>

      <div className="mc-field">
        <span className="mc-field-label">1. Carte grise</span>
        <label className="mc-dropzone">
          <span className="mc-dropzone-icon">
            <ion-icon
              name={state.registrationFile ? 'checkmark-circle-outline' : 'document-text-outline'}
            ></ion-icon>
          </span>
          <strong>
            {state.registrationFile ? 'Carte grise ajoutée' : 'Ajoutez votre carte grise'}
          </strong>
          <span className="mc-dropzone-hint">Photo nette, recto uniquement · JPG, PNG ou WEBP</span>
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            onChange={(e) => pickRegistration(e.target.files[0])}
          />
        </label>
      </div>

      <div className="mc-field">
        <span className="mc-field-label">2. Photos du véhicule</span>
        <label className="mc-dropzone">
          <span className="mc-dropzone-icon">
            <ion-icon name="cloud-upload-outline"></ion-icon>
          </span>
          <strong>Ajoutez vos photos</strong>
          <span className="mc-dropzone-hint">Extérieur et intérieur, en pleine lumière</span>
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            multiple
            onChange={(e) => {
              addPhotos(e.target.files);
              e.target.value = '';
            }}
          />
        </label>

        {state.photos.length > 0 && (
          <div className="mc-upload-grid">
            {state.photos.map((p) => (
              <div className="mc-upload-tile" key={p.id}>
                <img src={p.preview} alt="" />
                {p.status !== 'done' && (
                  <span className="mv-express-badge">
                    {p.status === 'uploading' ? 'Envoi…' : 'Échec'}
                  </span>
                )}
                <button
                  type="button"
                  className="mv-express-remove"
                  onClick={() => removePhoto(p)}
                  aria-label="Retirer la photo"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mc-form-alert mc-form-alert--info" role="note">
        <ion-icon name="lock-closed-outline"></ion-icon>
        <span>
          Votre carte grise sert uniquement à lire marque, modèle, année, carburant et places.
          Moovicar ne la conserve pas et ne lit ni votre nom ni votre adresse.
        </span>
      </div>

      <div className="mc-form-actions">
        <button type="button" className="mc-btn mc-btn--ghost" onClick={onSkip} disabled={busy}>
          Remplir à la main
        </button>
        <button
          type="button"
          className="mc-btn mc-btn--primary"
          onClick={onAnalyze}
          disabled={!ready || busy}
        >
          {busy ? (
            <>
              <span className="mc-spinner" aria-hidden="true"></span> Analyse en cours…
            </>
          ) : (
            <>
              Analyser et continuer
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </>
          )}
        </button>
      </div>
    </section>
  );
}

export default StepDocuments;
